module.exports = __webpack_public_path__ + "assets/383ccb0f8d011f64a05901bc073c42d5.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-LightItalic.woff
 ** module id = 1737
 ** module chunks = 1
 **/